import Reveal from '@/components/base/Reveal';
import { tags } from '@/mocks/homeData';

function TagIndex() {
  return (
    <section id="tags" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl">
          <Reveal>
            <div className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-10">
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                <div className="flex items-center gap-3">
                  <span className="flex items-center justify-center w-10 h-10 rounded-md bg-secondary-500 text-background-50 text-xl">
                    <i className="ri-price-tag-3-line" />
                  </span>
                  <div>
                    <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950">标签索引</h2>
                    <p className="mt-1 text-sm text-foreground-600 font-label">
                      按标签横向找内容，比逐层点进去更快。
                    </p>
                  </div>
                </div>
                <span className="inline-flex items-center gap-1 h-9 px-3 rounded-full bg-background-50 border border-background-200 text-xs font-label text-foreground-700 whitespace-nowrap self-start md:self-auto">
                  <i className="ri-hashtag" />
                  共 20 个热门标签
                </span>
              </div>

              <div className="mt-6 flex flex-wrap gap-2 md:gap-2.5">
                {tags.map((tag, index) => (
                  <a
                    key={tag}
                    href="#latest"
                    className={`inline-flex items-center h-9 px-4 rounded-full text-sm font-label whitespace-nowrap transition-colors ${
                      index % 5 === 0
                        ? 'bg-accent-100 text-accent-900 hover:bg-accent-500 hover:text-foreground-950'
                        : index % 3 === 0
                          ? 'bg-primary-100 text-primary-700 hover:bg-primary-500 hover:text-background-50'
                          : 'bg-background-50 border border-background-200 text-foreground-800 hover:border-primary-300 hover:text-primary-600'
                    }`}
                  >
                    {tag}
                  </a>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

export default TagIndex;